<template>
  <v-row justify="center">
    <v-dialog v-model="attivo" persistent>
      <v-form
        ref="form"
        @submit.prevent="onSubmit"
        v-model="valid"
        lazy-validation
      >
        <v-card>
          <v-card-title>
            <span class="text-h5">{{ $t("studiprevi.titolo") }}</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-expansion-panels v-model="pannelli" multiple>
                <v-expansion-panel v-if="false">
                  <v-expansion-panel-header disable-icon-rotate>
                    <v-chip class="ma-2" label color="primary">
                      {{ $t("studiprevi.studiPreuni") }}
                    </v-chip>
                    <template v-slot:actions>
                      <v-icon color="primary">
                        $expand
                      </v-icon>
                    </template>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-row>
                      <v-col cols="12">
                        <v-text-field
                          v-model="studiPrevi.preUniversitari.titolo_studio"
                          v-bind:label="
                            ciclo_scelto.CODICENU == 999
                              ? $t('studiprevi.titoloStudio')
                              : $t('studiprevi.titoloStudio') + ' *'
                          "
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6">
                        <v-text-field
                          v-model="studiPrevi.preUniversitari.istituto"
                          v-bind:label="
                            ciclo_scelto.CODICENU == 999
                              ? $t('studiprevi.istituto')
                              : $t('studiprevi.istituto') + ' *'
                          "
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="3">
                        <v-text-field
                          v-model="studiPrevi.preUniversitari.annoConseguimento"
                          v-bind:label="
                            ciclo_scelto.CODICENU == 999
                              ? $t('studiprevi.anno')
                              : $t('studiprevi.anno') + ' *'
                          "
                          v-mask="'####'"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="3">
                        <v-text-field
                          v-if="false"
                          v-model="studiPrevi.preUniversitari.votazione"
                          v-bind:label="
                            ciclo_scelto.CODICENU == 999
                              ? $t('studiprevi.votazione')
                              : $t('studiprevi.votazione') + ' *'
                          "
                          required
                        ></v-text-field>
                      </v-col>
                    </v-row>
                  </v-expansion-panel-content>
                </v-expansion-panel>

                <v-expansion-panel v-if="false">
                  <v-expansion-panel-header disable-icon-rotate>
                    <v-chip class="ma-2" label color="primary">
                      {{ $t("studiprevi.studiFilosofia") }}
                    </v-chip>
                    <template v-slot:actions>
                      <v-icon color="primary">
                        $expand
                      </v-icon>
                    </template>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-row>
                      <v-col cols="12">
                        <v-text-field
                          v-model="studiPrevi.filosofia.titolo_studio"
                          v-bind:label="$t('studiprevi.titoloStudio')"
                          :rules="[
                            (v) =>
                              !/[^A-Za-z0-9À-ú ]/.test(v) ||
                              $t('carattereNonValido'),
                          ]"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6">
                        <v-text-field
                          v-model="studiPrevi.filosofia.istituto"
                          v-bind:label="$t('studiprevi.istituto')"
                          :rules="[
                            (v) =>
                              !/[^A-Za-z0-9À-ú ]/.test(v) ||
                              $t('carattereNonValido'),
                          ]"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="3">
                        <v-text-field
                          v-model="studiPrevi.filosofia.annoConseguimento"
                          v-bind:label="$t('studiprevi.anno')"
                          v-mask="'####'"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="3">
                        <v-text-field
                          v-if="false"
                          v-model="studiPrevi.filosofia.votazione"
                          v-bind:label="$t('studiprevi.votazione')"
                          :rules="[
                            (v) =>
                              !/[^A-Za-z0-9À-ú ]/.test(v) ||
                              $t('carattereNonValido'),
                          ]"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                  </v-expansion-panel-content>
                </v-expansion-panel>

                <v-expansion-panel>
                  <v-expansion-panel-header disable-icon-rotate>
                    <v-chip class="ma-2" label color="primary">
                      {{ $t("studiprevi.studiTeologia") }}
                    </v-chip>
                    <template v-slot:actions>
                      <v-icon color="primary">
                        $expand
                      </v-icon>
                    </template>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-row>
                      <v-col cols="12">
                        <v-text-field
                          v-model="studiPrevi.teologia.titolo_studio"
                          v-bind:label="$t('studiprevi.titoloStudio')"
                          :rules="[
                            (v) =>
                              !/[^A-Za-z0-9À-ú ]/.test(v) ||
                              $t('carattereNonValido'),
                          ]"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6">
                        <v-text-field
                          v-model="studiPrevi.teologia.istituto"
                          v-bind:label="$t('studiprevi.istituto')"
                          :rules="[
                            (v) =>
                              !/[^A-Za-z0-9À-ú ]/.test(v) ||
                              $t('carattereNonValido'),
                          ]"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="3">
                        <v-text-field
                          v-model="studiPrevi.teologia.annoConseguimento"
                          v-bind:label="$t('studiprevi.anno')"
                          v-mask="'####'"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="3">
                        <v-text-field
                          v-if="false"
                          v-model="studiPrevi.teologia.votazione"
                          v-bind:label="$t('studiprevi.votazione')"
                          :rules="[
                            (v) =>
                              !/[^A-Za-z0-9À-ú ]/.test(v) ||
                              $t('carattereNonValido'),
                          ]"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                  </v-expansion-panel-content>
                </v-expansion-panel>

                <v-expansion-panel>
                  <v-expansion-panel-header disable-icon-rotate>
                    <v-chip class="ma-2" label color="primary">
                      {{ $t("studiprevi.studiAltro") }}
                    </v-chip>
                    <template v-slot:actions>
                      <v-icon color="primary">
                        $expand
                      </v-icon>
                    </template>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-row>
                      <v-col cols="12">
                        <v-text-field
                          v-model="studiPrevi.altro.titolo_studio"
                          v-bind:label="$t('studiprevi.titoloStudio')"
                          :rules="[
                            (v) =>
                              !/[^A-Za-z0-9À-ú ]/.test(v) ||
                              $t('carattereNonValido'),
                          ]"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6">
                        <v-text-field
                          v-model="studiPrevi.altro.istituto"
                          v-bind:label="$t('studiprevi.istituto')"
                          :rules="[
                            (v) =>
                              !/[^A-Za-z0-9À-ú ]/.test(v) ||
                              $t('carattereNonValido'),
                          ]"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="3">
                        <v-text-field
                          v-model="studiPrevi.altro.annoConseguimento"
                          v-bind:label="$t('studiprevi.anno')"
                          v-mask="'####'"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="3">
                        <v-text-field
                          v-if="false"
                          v-model="studiPrevi.altro.votazione"
                          v-bind:label="$t('studiprevi.votazione')"
                          :rules="[
                            (v) =>
                              !/[^A-Za-z0-9À-ú ]/.test(v) ||
                              $t('carattereNonValido'),
                          ]"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                  </v-expansion-panel-content>
                </v-expansion-panel>

                <v-expansion-panel>
                  <v-expansion-panel-header disable-icon-rotate>
                    <v-chip class="ma-2" label color="primary">
                      {{ $t("studiprevi.lingue.titolo") }}
                    </v-chip>
                    <template v-slot:actions>
                      <v-icon color="primary">
                        $expand
                      </v-icon>
                    </template>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-chip class="ma-2" color="amber" label text-color="black">
                      {{ $t("studiprevi.lingue.antiche") }}
                    </v-chip>

                    <v-list>
                      <v-list-item>
                        <h6>{{ $t("studiprevi.lingue.latina") }}:</h6>

                        <v-list-item-content>
                          <rate
                            :length="3"
                            v-model="studiPrevi.lingueAntiche.latina"
                            :ratedesc="[
                              $t('studiprevi.lingue.livello.discreto'),
                              $t('studiprevi.lingue.livello.buono'),
                              $t('studiprevi.lingue.livello.eccellente'),
                            ]"
                          />
                        </v-list-item-content>
                        <h6>{{ $t("studiprevi.lingue.greca") }}:</h6>
                        <v-list-item-content>
                          <rate
                            :length="3"
                            v-model="studiPrevi.lingueAntiche.greca"
                            :ratedesc="[
                              $t('studiprevi.lingue.livello.discreto'),
                              $t('studiprevi.lingue.livello.buono'),
                              $t('studiprevi.lingue.livello.eccellente'),
                            ]"
                          />
                        </v-list-item-content>
                        <h6>{{ $t("studiprevi.lingue.ebraica") }}:</h6>
                        <v-list-item-content>
                          <rate
                            :length="3"
                            v-model="studiPrevi.lingueAntiche.ebraica"
                            :ratedesc="[
                              $t('studiprevi.lingue.livello.discreto'),
                              $t('studiprevi.lingue.livello.buono'),
                              $t('studiprevi.lingue.livello.eccellente'),
                            ]"
                          />
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                    <v-divider></v-divider>
                    <v-chip class="ma-2" color="amber" label text-color="black">
                      {{ $t("studiprevi.lingue.moderne") }}
                    </v-chip>

                    <v-list>
                      <v-list-item>
                        <h6>{{ $t("studiprevi.lingue.francese") }}:</h6>
                        <v-list-item-content>
                          <rate
                            :length="3"
                            v-model="studiPrevi.lingueModerne.francese"
                            :ratedesc="[
                              $t('studiprevi.lingue.livello.discreto'),
                              $t('studiprevi.lingue.livello.buono'),
                              $t('studiprevi.lingue.livello.eccellente'),
                            ]"
                          />
                        </v-list-item-content>
                        <h6>{{ $t("studiprevi.lingue.inglese") }}:</h6>
                        <v-list-item-content>
                          <rate
                            :length="3"
                            v-model="studiPrevi.lingueModerne.inglese"
                            :ratedesc="[
                              $t('studiprevi.lingue.livello.discreto'),
                              $t('studiprevi.lingue.livello.buono'),
                              $t('studiprevi.lingue.livello.eccellente'),
                            ]"
                          />
                        </v-list-item-content>
                        <h6>{{ $t("studiprevi.lingue.italiana") }}:</h6>
                        <v-list-item-content>
                          <rate
                            :length="3"
                            v-model="studiPrevi.lingueModerne.italiana"
                            :ratedesc="[
                              $t('studiprevi.lingue.livello.discreto'),
                              $t('studiprevi.lingue.livello.buono'),
                              $t('studiprevi.lingue.livello.eccellente'),
                            ]"
                          />
                        </v-list-item-content>
                        <h6>{{ $t("studiprevi.lingue.spagnola") }}:</h6>
                        <v-list-item-content>
                          <rate
                            :length="3"
                            v-model="studiPrevi.lingueModerne.spagnola"
                            :ratedesc="[
                              $t('studiprevi.lingue.livello.discreto'),
                              $t('studiprevi.lingue.livello.buono'),
                              $t('studiprevi.lingue.livello.eccellente'),
                            ]"
                          />
                        </v-list-item-content>
                        <h6>{{ $t("studiprevi.lingue.tedesca") }}:</h6>
                        <v-list-item-content>
                          <rate
                            :length="3"
                            v-model="studiPrevi.lingueModerne.tedesca"
                            :ratedesc="[
                              $t('studiprevi.lingue.livello.discreto'),
                              $t('studiprevi.lingue.livello.buono'),
                              $t('studiprevi.lingue.livello.eccellente'),
                            ]"
                          />
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                    <v-btn class="ma-2" dark x-small @click="resetLingue">
                      <v-icon dark left> mdi-eraser </v-icon
                      >{{ $t("studiprevi.lingue.reset") }}
                    </v-btn>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer
              ><small>({{ $t("campiObbligatori") }})</small></v-spacer
            >
            <v-btn color="primary darken-1" @click="validazione">
              {{ $t("conferma") }}
            </v-btn>
            <v-btn color="primary darken-1" text @click="chiudi">
              {{ $t("chiudi") }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
    <v-snackbar
      v-model="snackbar"
      :timeout="timeout"
      elevation="24"
      color="primary"
    >
      <b>{{ $t("checkCampiObbligatori") }}</b>
    </v-snackbar>
  </v-row>
</template>

<script>
//import api from '@/services/EventService.js'

export default {
  name: "studiprevi",

  props: {
    attivo: {
      default: false,
      type: Boolean,
    },
  },
  data: () => ({
    snackbar: false,
    timeout: 2000,
    dialog: true,
    pannelli: [0, 1, 2, 3, 4],
    lingueAntiche: [{ desc: "Latina" }, { desc: "greca" }, { desc: "ebraica" }],
  }),
  methods: {
    resetLingue() {
      this.studiPrevi.lingueAntiche = {
        latina: null,
        greca: null,
        ebraica: null,
      };
      this.studiPrevi.lingueModerne = {
        francese: null,
        inglese: null,
        italiana: null,
        spagnola: null,
        tedesca: null,
      };
    },

    async chiudi() {
      if (!this.$refs.form.validate()) {
        await this.$store.dispatch("setStepNoCompletoEvent", 4);
      }
      this.attivo = false;
    },
    async validazione() {
      if (this.$refs.form.validate()) {
        await this.$store.dispatch("setStepCompletoEvent", 4);
        this.attivo = false;
      } else {
        this.snackbar = true;
      }
    },
  },
  computed: {
    studiPrevi() {
      return this.$store.state.studiprevi;
    },
    ciclo_scelto() {
      return this.$store.getters.riepilogoGenerale.iscrizione.dati.ciclo_scelto;
    },
  },
  mounted: function() {},
  updated: function() {},

  watch: {},
};
</script>
